import {commonService} from "./common.services";
export  const userService = {
    getAllUsers,
    createUser
}

function getAllUsers(data) {

    return commonService.sendHttpRequest('rbuilder/listusers', data, "GET");
}
function createUser(data) {
    return commonService.sendHttpRequest('rbuilder/saveuser', data, "POST");
}



// WEBPACK FOOTER //
// ./src/services/user.services.js